import { useEffect, useState } from 'react'

import useFetchWrapper, { HttpResponse } from '../../../Helpers/useFetchWrapper';

import { NetworkUser, Props, TabStatus } from './NetworkTab.model';

const useNetworkTab = ({ id, userId, navigateTo }: Props) => {
  const [ network, setNetwork ] = useState<NetworkUser[]>([]);
  const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);

  const { get } = useFetchWrapper();

  useEffect(() => {
    getNetwork();
  }, [id]);

  const getNetwork = async () => {
    const response: HttpResponse<NetworkUser[]> = await get(`/user/profile/network/${id}?page=1&size=100`);

    response.parsedBody && setNetwork(response.parsedBody);
    
		setTabStatus(TabStatus.Loaded);
  }

  const onClickNetworkItem = (id: string) => {
    const path = userId !== id ? `/members-list/${id}` : '/my-profile';
    navigateTo(path);
  }

  return {
    onClickNetworkItem,
    state: {
      network,
      tabStatus,
    },
  }

}
export default useNetworkTab;